import { ApiError, FeatureApiService, FeatureFlagName } from '@api'
import { attach, createEffect, createStore, sample } from 'effector'

import { handleError } from '@/utils/error'

import { $isLoggedIn } from './account'
import { $creatorId } from './creators'
import { initializeApp } from './init'

export const getAvailableFeaturesFx = attach({
  name: 'get feature flags',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (_: void, { creatorId }) => ({
    creatorId: creatorId ?? 0,
  }),
  effect: createEffect<
    {
      creatorId: number
    },
    FeatureFlagName[],
    ApiError
  >(FeatureApiService.getAvailableFeatures),
})

getAvailableFeaturesFx.failData.watch((error) => {
  handleError(
    error,
    'Something went wrong while getting available features',
    getAvailableFeaturesFx,
  )
})

export const $availableFeatures = createStore<FeatureFlagName[] | null>(
  null,
).on(getAvailableFeaturesFx.doneData, (_, features) => features)

// TODO: should be removed in scope of DEV-5062
export const $ableToReassignSales = $availableFeatures.map(
  (features) => !!features?.includes(FeatureFlagName.REASSIGN_SALES),
)

sample({
  clock: [$creatorId, initializeApp, $isLoggedIn],
  source: { creatorId: $creatorId, isLoggedIn: $isLoggedIn },
  filter: ({ isLoggedIn }) => !!isLoggedIn,
  target: getAvailableFeaturesFx,
})
